export default __webpack_public_path__ + "static/8-5495bfdcd94c431353b003135b00207b.jpg";